import React from 'react';
import $ from 'jquery';
import server from '../functions/server';
import { Button, Icon } from 'semantic-ui-react'

import { Add } from '@material-ui/icons/';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function FormDialog(props) {
  const [open, setOpen] = React.useState(false);
  const [load, setLoad] = React.useState(false);
  const [title, setTitle] = React.useState('');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const add = () => {
    if (!title.length) {
      alert('Enter Title!!!');
      return;
    }
    $.ajax({
      type: "POST", url: server() + '/banners/add.php', 
      data: { title, shop_id: props.shopId, priority: -1 }, 
      beforeSend: () => setLoad(true),
      success: (data) => {
        console.log(data);
        if (data === "1") {
          setOpen(false);
          props.getBanners();
        } else {
          alert("Duplicate Entry OR Failed");
        }
        setLoad(false);
      }, error: (e) => {
        console.log(e);
        alert("Error");
        setLoad(false);
      }
    });
  }

  return (
    <>
      <Button
        style={{ marginRight: 10 }}
        floated='right'
        positive
        onClick={handleClickOpen}>
        <Icon name='add'/>
        Add Banner
      </Button>
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Add Banner</DialogTitle>
        <DialogContent>
          <DialogContentText>Add Banner to display in Home page</DialogContentText>
          <TextField autoFocus value={title} margin="dense" id="title" label="Title" type="name" onChange={(e) => setTitle(e.target.value)} fullWidth />
        </DialogContent>
        <DialogActions>
          <Button disabled={load} onClick={handleClose} color="danger">Cancel</Button>
          <Button loading={load} onClick={add} color="primary">Add</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
